import { render, staticRenderFns } from "./BuildingOutlinedIcon.vue?vue&type=template&id=a21db600&"
import script from "./BuildingOutlinedIcon.vue?vue&type=script&lang=ts&"
export * from "./BuildingOutlinedIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports